var getDisplayName = function (WrappedComponent) { return WrappedComponent.displayName || WrappedComponent.name || 'Component'; };
export default getDisplayName;
//# sourceMappingURL=getDisplayName.js.map